@if (selectedItems().length > 1) {
	<div class="chip" nhaTest="filtered-dropdown">
		<span class="chip-content">
			{{ filterTitle() }}
			<button mat-icon-button class="chip-button" [matMenuTriggerFor]="overflowOptions" nhaTest="expand-dropdown">
				<mat-icon>expand_more</mat-icon>
			</button>
		</span>

		<mat-menu #overflowOptions="matMenu" nhaTest="filtered-list">
			@if (!locked()) {
				<div class="selected-filter-dropdown-menu-item">
					<button mat-button (click)="onDeselectAll()"><mat-icon>close</mat-icon>Clear all</button>
				</div>
			}

			@for (item of selectedItems(); track item.id) {
				<div class="selected-filter-dropdown-menu-item">
					<span nhaTest="filtered-item" class="filtered-item">{{ item.label }}</span>
					@if (locked()) {
						<mat-icon>lock</mat-icon>
					} @else {
						<button mat-icon-button class="dropdown-menu-item-button" nhaTest="remove-filter" (click)="onDeselectItem(item)" [disabled]="locked()">
							<mat-icon>cancel</mat-icon>
						</button>
					}
				</div>
			}
		</mat-menu>
	</div>
} @else {
	@for (item of selectedItems(); track item.id) {
		<div class="chip" nhaTest="filtered-item" [matTooltip]="'Filter Selection Locked'" [matTooltipDisabled]="!locked()">
			<span class="chip-content">
				{{ filterTitle() }}: {{ item.label }}
				@if (!locked()) {
					<button mat-icon-button class="chip-button" nhaTest="remove-filter" (click)="onDeselectItem(item)">
						<mat-icon>cancel</mat-icon>
					</button>
				}
			</span>
		</div>
	}
}
